import { z } from "zod"

// Matches the Prisma `Language` enum. The values are BCP-47 codes so they can
// be passed straight to Intl, date-fns and next-intl.
export const LanguageSchema = z.enum(["sv", "en"])

export type Language = z.infer<typeof LanguageSchema>

export const LANGUAGES = LanguageSchema.options

export const DEFAULT_LANGUAGE: Language = "sv"

export const LANGUAGE_INTL_LOCALES: Record<Language, string> = {
  sv: "sv-SE",
  en: "en-GB",
}

export const isLanguage = (value: string): value is Language =>
  LanguageSchema.safeParse(value).success

// Dates in both apps are shown in Swedish time regardless of language
export const STOCKHOLM_TIME_ZONE = "Europe/Stockholm"

// Sent by alfred and julo so the API returns DB-backed names (parts) in the
// UI's language. Lower-case, as Node exposes incoming header names.
export const LANGUAGE_HEADER = "julo-language"
